export var dscr = {
    "dscr": {
        "id": "15183-df-www",
        "dynamicform": "https://www.newamericanfunding.com/df/dscr/",
        "templateType": "standard",
        "layout": {
            "templateType": "standard",
            "navGroups": []
        },
        "pages": [
            "15183_loanPurpose"
        ],
        "subFlows": {
            "purchase": {
                "path": "https://www.newamericanfunding.com/df/dscr/#15183_purchase",
                "visible": [
                    "equal",
                    "loanPurpose",
                    "purchase"
                ],
                "pages": [
                    "15183_loanPurpose",
                    "15175_occupancy",
                    "15173_propertyType",
                    "15272_propertyAddress",
                    "13799_loanAmt_P",
                    "15178_exitStrategy",
                    "13786_estimateCreditRating",
                    "15180_liquidity",
                    "15179_planToQualify",
                    "13791_FirstName&LastName",
                    "13788_Email",
                    "13802_phone"
                ]
            },
            "refinance": {
                "path": "https://www.newamericanfunding.com/df/dscr/#15183_refinance",
                "visible": [
                    "equal",
                    "loanPurpose",
                    "refinance"
                ],
                "pages": [
                    "15183_loanPurpose",
                    "15175_occupancy",
                    "15174_propertyType",
                    "15272_propertyAddress",
                    "13810_homeValueAmt",
                    "15178_exitStrategy",
                    "13786_estimateCreditRating",
                    "15180_liquidity",
                    "15179_planToQualify",
                    "13791_FirstName&LastName",
                    "13788_Email",
                    "13802_phone"
                ]
            },
            "cashout": {
                "path": "https://www.newamericanfunding.com/df/dscr/#15183_cashout",
                "visible": [
                    "equal",
                    "loanPurpose",
                    "cashout"
                ],
                "pages": [
                    "15183_loanPurpose",
                    "15175_occupancy",
                    "15174_propertyType",
                    "15272_propertyAddress",
                    "13810_homeValueAmt",
                    "13806_cashOutAmt",
                    "15178_exitStrategy",
                    "13786_estimateCreditRating",
                    "15180_liquidity",
                    "15179_planToQualify",
                    "13791_FirstName&LastName",
                    "13788_Email",
                    "13802_phone"
                ]
            }
        },
        "templateCollection": {
            "NAF_HomePage": "root",
            "NAF_DynamicForm": "parent",
            "NAF_DynamicFormStandardPage": "standard",
            "NAF_DynamicFormLeftNavPage": "leftnav"
        },
        "pageCollection": {
            "15183_loanPurpose": {
                "title": "Choose your loan type",
                "subtext": "",
                "questions": [
                    "loanPurpose"
                ],
                "category": ""
            },
            "15175_occupancy": {
                "title": "How will your property be used?",
                "subtext": null,
                "questions": [
                    "15175_occupancy"
                ]
            },
            "15173_propertyType": {
                "title": "What type of property are you purchasing?",
                "subtext": null,
                "questions": [
                    "15173_propertyType"
                ]
            },
            "15272_propertyAddress": {
                "title": "What is the property address?",
                "subtext": null,
                "questions": [
                    "15272_propertyAddress"
                ]
            },
            "13799_loanAmt_P": {
                "title": "What is the estimated purchase price?",
                "subtext": "Just an estimate is fine. You can update the amount later in the process.",
                "questions": [
                    "13799_loanAmt_P"
                ]
            },
            "15178_exitStrategy": {
                "title": "What is your exit strategy?",
                "subtext": null,
                "questions": [
                    "15178_exitStrategy"
                ]
            },
            "13786_estimateCreditRating": {
                "title": "How would you rate your credit?",
                "subtext": null,
                "questions": [
                    "13786_estimateCreditRating"
                ]
            },
            "15180_liquidity": {
                "title": "What is your current liquidity?",
                "subtext": null,
                "questions": [
                    "15180_liquidity"
                ]
            },
            "15179_planToQualify": {
                "title": "How do you plan to qualify?",
                "subtext": null,
                "questions": [
                    "15179_planToQualify"
                ]
            },
            "13791_FirstName&LastName": {
                "title": "Please enter your name below",
                "subtext": "<i class=\"fa-solid fa-lock\" aria-hidden=\"true\" style=\"font-size: .875rem; color: #d7b963; padding-right: 5px;\"></i> Your privacy is protected.",
                "questions": [
                    "13791_firstName",
                    "13791_lastName"
                ]
            },
            "13788_Email": {
                "title": "What is your e-mail address?",
                "subtext": "We adhere to a strict privacy policy and will never sell your information.",
                "questions": [
                    "13788_email"
                ]
            },
            "13802_phone": {
                "title": "What is your phone number?",
                "subtext": "We adhere to a strict privacy policy and will never sell your information.",
                "disclosure": "**By entering my phone number above, I agree to receive recurring automated text messages at the phone number provided. Consent is not a condition to purchase. Msg & data rates may apply. Msg frequency varies.",
                "hideDisclosure": true,
                "questions": [
                    "13802_phone"
                ]
            },
            "15174_propertyType": {
                "title": "What type of home are you refinancing?",
                "subtext": null,
                "questions": [
                    "15174_propertyType"
                ]
            },
            "13810_homeValueAmt": {
                "title": "What's your home's value?",
                "subtext": null,
                "questions": [
                    "13810_homeValueAmt"
                ]
            },
            "13806_cashOutAmt": {
                "title": "How much cash do you want to borrow?",
                "subtext": null,
                "questions": [
                    "13806_cashOutAmt"
                ]
            }
        },
        "questionCollection": {
            "15175_occupancy": {
                "type": "radio",
                "fieldId": "occupancy",
                "answerOptions": [
                    {
                        "text": "Primary Residence",
                        "value": "Primary Residence"
                    },
                    {
                        "text": "Secondary Home",
                        "value": "Secondary Home"
                    },
                    {
                        "text": "Investment Property",
                        "value": "Investment Property"
                    },
                    {
                        "text": "Owner Occupied",
                        "value": "Owner Occupied"
                    }
                ]
            },
            "15173_propertyType": {
                "type": "radio",
                "fieldId": "propertyType",
                "answerOptions": [
                    {
                        "text": "Single Family Home",
                        "value": "Single Family Home"
                    },
                    {
                        "text": "Multi-Family Home",
                        "value": "Multi-Family Home"
                    },
                    {
                        "text": "Townhouse / Condo",
                        "value": "Townhouse / Condo"
                    },
                    {
                        "text": "Manufactured Home",
                        "value": "Manufactured Home"
                    },
                    {
                        "text": "Commercial",
                        "value": "Commercial"
                    },
                    {
                        "text": "Hotel / Motel",
                        "value": "Hotel / Motel"
                    },
                    {
                        "text": "Other",
                        "value": "Other"
                    }
                ]
            },
            "15272_propertyAddress": {
                "type": "autoAddress",
                "fieldId": "propertyAddress",
                "required": true,
                "placeholder": "Enter property address",
                "autoComplete": "off",
                "autoCorrect": "off",
                "spellCheck": "false"
            },
            "13799_loanAmt_P": {
                "type": "inputText",
                "inputType": "currency",
                "fieldId": "loanAmt_P",
                "questionTitle": "What is the estimated purchase price?",
                "includeSlider": true,
                "sliderMinValue": 25000,
                "sliderMaxValue": 10000000,
                "sliderStepValue": 25000,
                "validation": [
                    [
                        "required"
                    ],
                    [
                        "min",
                        25000,
                        "Min: $25,000"
                    ],
                    [
                        "max",
                        10000000,
                        "Max: $10,000,000"
                    ]
                ]
            },
            "15178_exitStrategy": {
                "type": "radio",
                "fieldId": "exitStrategy",
                "answerOptions": [
                    {
                        "text": "Flip",
                        "value": "Flip"
                    },
                    {
                        "text": "Sell",
                        "value": "Sell"
                    },
                    {
                        "text": "Hold",
                        "value": "Hold"
                    }
                ]
            },
            "13786_estimateCreditRating": {
                "type": "radio",
                "fieldId": "estimateCreditRating",
                "answerOptions": [
                    {
                        "text": "Excellent (720+)",
                        "value": "Excellent (720+)"
                    },
                    {
                        "text": "Good (680 – 719)",
                        "value": "Good (680 – 719)"
                    },
                    {
                        "text": "Fair (620 – 679)",
                        "value": "Fair (620 – 679)"
                    },
                    {
                        "text": "Poor (580 - 619)",
                        "value": "Poor (580 - 619)"
                    },
                    {
                        "text": "Below < 580",
                        "value": "Below < 580"
                    }
                ]
            },
            "15180_liquidity": {
                "type": "radio",
                "fieldId": "liquidity",
                "answerOptions": [
                    {
                        "text": "No liquidity",
                        "value": "No liquidity"
                    },
                    {
                        "text": "Less than $25k",
                        "value": "Less than $25k"
                    },
                    {
                        "text": "$25k to $50k",
                        "value": "$25k to $50k"
                    },
                    {
                        "text": "$50k to $100k",
                        "value": "$50k to $100k"
                    },
                    {
                        "text": "More than $100k",
                        "value": "More than $100k"
                    },
                    {
                        "text": "Other",
                        "value": "Other"
                    }
                ]
            },
            "15179_planToQualify": {
                "type": "radio",
                "fieldId": "planToQualify",
                "answerOptions": [
                    {
                        "text": "W2 / Tax Returns",
                        "value": "W2 / Tax Returns"
                    },
                    {
                        "text": "Bank Statements",
                        "value": "Bank Statements"
                    },
                    {
                        "text": "Rental Income",
                        "value": "Rental Income"
                    },
                    {
                        "text": "1099 Income",
                        "value": "1099 Income"
                    },
                    {
                        "text": "Other",
                        "value": "Other"
                    }
                ]
            },
            "13791_firstName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "firstName",
                "name": "Textbox | First Name",
                "label": "First Name",
                "autoComplete": "given-name",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 2,
                "maxLength": 50,
                "pattern": "^[A-Za-z]{2}[A-Za-z -]*$",
                "validation": [
                    [
                        "required",
                        "Required"
                    ],
                    [
                        "pattern",
                        "^[A-Za-z]{2}[A-Za-z -]*$",
                        "Must start with two letters. Only letters, spaces and hyphens are allowed."
                    ],
                    [
                        "minLength",
                        2,
                        "Min 2 letters"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 letters"
                    ]
                ]
            },
            "13791_lastName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "lastName",
                "name": "Textbox | Last Name",
                "label": "Last Name",
                "autoComplete": "family-name",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 2,
                "maxLength": 50,
                "pattern": "^[A-Za-z]{2}[A-Za-z -]*$",
                "validation": [
                    [
                        "required",
                        "Required"
                    ],
                    [
                        "pattern",
                        "^[A-Za-z]{2}[A-Za-z -]*$",
                        "Must start with two letters. Only letters, spaces and hyphens are allowed."
                    ],
                    [
                        "minLength",
                        2,
                        "Min 2 letters"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 letters"
                    ]
                ]
            },
            "13791_FirstName&LastName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "FirstName&LastName"
            },
            "13788_email": {
                "type": "inputText",
                "inputType": "email",
                "fieldId": "email",
                "name": "Textbox | Email Address",
                "label": "Email Address",
                "placeholder": "@",
                "autoComplete": "email",
                "autoCorrect": "off",
                "spellCheck": "false",
                "maxLength": 50,
                "pattern": "^[a-zA-Z0-9_+-](?:[a-zA-Z0-9._+-])*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
                "validation": [
                    [
                        "required",
                        "Required"
                    ],
                    [
                        "pattern",
                        "^[a-zA-Z0-9_+-](?:[a-zA-Z0-9._+-])*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
                        "Invalid Email Address"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 characters"
                    ]
                ]
            },
            "13788_Email": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "Email"
            },
            "13802_phone": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "phone",
                "name": "Textbox | Phone Number",
                "label": "Phone Number**",
                "labelAlt": "Phone Number",
                "placeholder": "(___) ___-____",
                "inputMask": "(999) 999-9999",
                "autoComplete": "tel-national",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 14,
                "maxLength": 14,
                "pattern": "[(][^01].*",
                "disclosure": "**By entering my phone number above, I agree to receive recurring automated text messages at the phone number provided. Consent is not a condition to purchase. Msg & data rates may apply. Msg frequency varies.",
                "hideDisclosure": true,
                "validation": [
                    [
                        "required",
                        "Phone number is required"
                    ],
                    [
                        "pattern",
                        "[(][^01].*",
                        "Phone area code invalid"
                    ],
                    [
                        "minLength",
                        14,
                        "10-Digit Phone #"
                    ],
                    [
                        "maxLength",
                        14
                    ],
                    [
                        "phone"
                    ]
                ]
            },
            "15174_propertyType": {
                "type": "radio",
                "fieldId": "propertyType",
                "answerOptions": [
                    {
                        "text": "Single Family Home",
                        "value": "Single Family Home"
                    },
                    {
                        "text": "Multi-Family Home",
                        "value": "Multi-Family Home"
                    },
                    {
                        "text": "Townhouse / Condo",
                        "value": "Townhouse / Condo"
                    },
                    {
                        "text": "Manufactured Home",
                        "value": "Manufactured Home"
                    },
                    {
                        "text": "Commercial",
                        "value": "Commercial"
                    },
                    {
                        "text": "Hotel / Motel",
                        "value": "Hotel / Motel"
                    },
                    {
                        "text": "Other",
                        "value": "Other"
                    }
                ]
            },
            "13810_homeValueAmt": {
                "type": "inputText",
                "inputType": "currency",
                "fieldId": "homeValueAmt",
                "questionTitle": "What's your home's value?",
                "includeSlider": true,
                "sliderMinValue": 25000,
                "sliderMaxValue": 10000000,
                "sliderStepValue": 25000,
                "validation": [
                    [
                        "required"
                    ],
                    [
                        "min",
                        25000,
                        "Minimum: $25,000"
                    ],
                    [
                        "max",
                        10000000
                    ]
                ]
            },
            "13806_cashOutAmt": {
                "type": "inputText",
                "inputType": "currency",
                "fieldId": "cashOutAmt",
                "questionTitle": "How much cash do you want to borrow?",
                "includeSlider": true,
                "sliderMaxValue": 10000000,
                "sliderStepValue": 25000,
                "defaultValue": 150000,
                "validation": [
                    [
                        "max",
                        10000000
                    ]
                ]
            },
            "loanPurpose": {
                "type": "radio",
                "fieldId": "loanPurpose",
                "answerOptions": [
                    {
                        "value": "purchase",
                        "text": "I am Purchasing",
                        "customIconImage": "https://images4.cmp.optimizely.com/assets/icon-money-house-white.svg/Zz0wNGM3Yzk3MmE1NDcxMWYwYTg4YmZlODA2M2VkN2E0Zg==",
                        "id": 15176
                    },
                    {
                        "value": "refinance",
                        "text": "I am Refinancing",
                        "customIconImage": "https://images2.cmp.optimizely.com/assets/icon-money-cycle-white.svg/Zz0wNGJjYzBmNGE1NDcxMWYwYmZmYmMyZTM4NmU1NGRmNQ==",
                        "id": 15181
                    },
                    {
                        "value": "cashout",
                        "text": "I am Cashing Out",
                        "customIconImage": "https://images2.cmp.optimizely.com/assets/icon-money-bag-white.svg/Zz0wNGFjMjBiNGE1NDcxMWYwYTEyNjRhMmI3MDczMjYzZA==",
                        "id": 15182
                    }
                ]
            }
        },
        "introDescription": "",
        "customIntroQuestion": "",
        "pageSpecificDisclosures": "",
        "_rid": "cUFDANRpTdkNAAAAAAAAAA==",
        "_self": "dbs/cUFDAA==/colls/cUFDANRpTdk=/docs/cUFDANRpTdkNAAAAAAAAAA==/",
        "_etag": "\"2e00df6c-0000-4d00-0000-69a741090000\"",
        "_attachments": "attachments/",
        "_ts": 1772568841,
        "parentPageCollection": {
            "id": "13820-parent-www",
            "dynamicform": "https://www.newamericanfunding.com/df/",
            "templateType": "parent",
            "defaultPhone": "(855) 276-3747",
            "formDisclosures": "<p>By clicking \"Submit\", I acknowledge that I have reviewed the&nbsp;<a href=\"/link/577ec19b835e45738672b6b71bfde1bf.aspx\" target=\"_blank\" rel=\"noopener\">Privacy Policy</a> and agree by ESIGN signature to the following:</p>\n<ol>\n<li>I am providing written instructions under the Fair Credit Reporting Act authorizing New American Funding (NAF) to obtain information from my personal credit profile or other information from a consumer reporting agency solely to conduct a prequalification for credit.</li>\n<li>Receive disclosures and communications about my loan inquiry and any loan that I obtain from NAF in electronic form. I confirm I have access to a working computer and/or digital device where I can view and manage my information.</li>\n<li>I consent to NAF, its&nbsp;<a href=\"/link/c24b75f81e1c4b30b55992ffefc566b5.aspx\" target=\"_blank\" rel=\"noopener\">partners</a>, and parties calling on their behalf to contact me at the number that I provided on the previous screen for marketing purposes, including through the use of email, automated technology, artificial or prerecorded voice, AI generative voice, and SMS/MMS messages. I acknowledge my consent is not required to obtain any good or service, and that I can be connected with NAF without providing consent by calling <a href=\"tel:+1-800-890-1057\">(800) 890-1057</a>. I consent to be contacted even if my phone number or email address appears on a NAF Do Not Contact/Do Not Email list, a State or National Do Not Call Registry or any other Do Not Contact/Do Not Email list.</li>\n<li>To the terms of NAF's <a href=\"/link/b5dcd8b0e78845529aa30fe9011f9036.aspx\" target=\"_blank\" rel=\"noopener\">Terms of Use</a>&nbsp;and&nbsp;<a href=\"/link/f5695fd0d410420d9271082ca3047d44.aspx\" target=\"_blank\" rel=\"noopener\">Electronic Consent Agreement</a>.</li>\n</ol>",
            "footerDisclosures": {
                "InternalFormat": "<p><strong>By using our site, you agree to our use of cookies. For more information, read our&nbsp;<a href=\"",
                "ReferencedPermanentLinkIds": []
            },
            "_rid": "cUFDANRpTdkJAAAAAAAAAA==",
            "_self": "dbs/cUFDAA==/colls/cUFDANRpTdk=/docs/cUFDANRpTdkJAAAAAAAAAA==/",
            "_etag": "\"21014ca0-0000-4d00-0000-6962aa840000\"",
            "_attachments": "attachments/",
            "_ts": 1768073860
        },
        "rootPageCollection": {
            "id": "15-root-www",
            "dynamicform": "https://www.newamericanfunding.com/",
            "templateType": "root",
            "copyright": "New American Funding, LLC. All Rights Reserved.",
            "corporateOfficeAddress": "1 MacArthur Place, Suite 800, Santa Ana, CA 92707",
            "legalLinks": [
                {
                    "Text": "NMLS ID#6606",
                    "Href": "https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/6606"
                },
                {
                    "Text": "State Licensing",
                    "Href": "https://www.newamericanfunding.com/legal/state-licensing/"
                },
                {
                    "Text": "Privacy Policy",
                    "Href": "https://www.newamericanfunding.com/legal/privacy-policy/"
                },
                {
                    "Text": "Terms of Use",
                    "Href": "https://www.newamericanfunding.com/legal/terms-of-use/"
                },
                {
                    "Text": "Terms of Use for Serviced Loans",
                    "Href": "https://www.newamericanfunding.com/legal/terms-of-use-for-serviced-loans/"
                },
                {
                    "Text": "Advertising Disclosures",
                    "Href": "https://www.newamericanfunding.com/legal/advertising-disclosures/"
                },
                {
                    "Text": "Electronic Consent Agreement",
                    "Href": "https://www.newamericanfunding.com/legal/electronic-consent-agreement/"
                },
                {
                    "Text": "Partners",
                    "Href": "https://www.newamericanfunding.com/legal/partners/"
                },
                {
                    "Text": "On-Time Closing Guarantee",
                    "Href": "https://www.newamericanfunding.com/legal/on-time-closing-guarantee/"
                },
                {
                    "Text": "NMLS Consumer Access",
                    "Href": "https://www.nmlsconsumeraccess.org/"
                },
                {
                    "Text": "State Disclosures for Serviced Loans",
                    "Href": "https://www.newamericanfunding.com/legal/state-disclosures-for-serviced-loans/"
                },
                {
                    "Text": "Cookie Policy",
                    "Href": "https://www.newamericanfunding.com/legal/cookie-policy/"
                },
                {
                    "Text": "California Collection Notice",
                    "Href": "https://www.newamericanfunding.com/legal/privacy-policy/#CAnotice"
                },
                {
                    "Text": "CA Privacy Policy",
                    "Href": "https://www.newamericanfunding.com/legal/ca-privacy-policy/"
                }
            ],
            "adaDisclosure": "If you are using a screen reader or other auxiliary aid and are having problems using this website, please call <a href=\"tel:800-450-2010\">800-450-2010</a> Ext. 7100 for assistance.",
            "_rid": "cUFDANRpTdkIAAAAAAAAAA==",
            "_self": "dbs/cUFDAA==/colls/cUFDANRpTdk=/docs/cUFDANRpTdkIAAAAAAAAAA==/",
            "_etag": "\"2e00da6c-0000-4d00-0000-69a73f360000\"",
            "_attachments": "attachments/",
            "_ts": 1772568374
        }
    }
};
